/**
 * 
 * key
 * 
 */


const key = 'bWFuYWdlUHJpbnRWZW5kb3I='

export default key 